<template>
    <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="addurl">
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("title") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="text"
            v-model="inputs.title"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_email" class="col-sm-3 mb-0">
            {{ $t("description") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.description"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_email" class="col-sm-3 mb-0">
            {{ $t("shortdescription") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.shortdescription"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_email" class="col-sm-3 mb-0">
            {{ $t("categorytag") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.categorytag"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("category") }}
          </label>
          <app-input
            type="search-select"
            class="col-sm-9"
            :placeholder="$t('category')"
            :list="this.categories"
            v-model="inputs.category"
          />
        </div>

        <div class="form-group row mb-0">
            <label class="col-sm-2 mb-sm-0">
              {{ $t("upload") }}
            </label>
            <div class="col-sm-8">
              <app-input
                type="custom-file-upload"
                :label="$t('upload_your_file')"
                v-model="inputs.image"
                :required="true"
              />
              <small class="text-muted font-italic">
                {{ $t("recommended_custom_file_validation") }}
              </small>
            </div>
          </div>
        <div class="row mt-2 text-right" >
            <div class="col-md-12">
                <button class="btn btn-secondary" @click.prevent="backFormAdd()">{{$t('back')}}</button>
                <button class="btn btn-primary" @click.prevent="submit()">{{$t('save')}}</button>
            </div>
        </div>
      </form>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import * as actions from "../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  mixins: [FormMixin],
  props: {
    back: Function,
  },
  data() {
    return {
      addurl: actions.CATEGORY_STORE,
      preloader: false,
      inputs: {},
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
      dropzone_files: [],
      categories: [],
    };
  },
  methods: {
    backFormAdd() {
      this.back(1);
    },
    submit() {
      let formData = new FormData();

      this.inputs.path =  this.inputs.image != null ? this.inputs.image['name'] : '';
      Object.keys(this.inputs).forEach((key) => {
        formData.append(key, this.inputs[key]);
      });
        this.save(formData);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.back(1);
    },
    getCategories() {
      axiosGet(CATEGORIES)
        .then((res) => {
          
          this.categories = res.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>
